import React from "react";
import { Accordion, Container, Row, Col } from "react-bootstrap";

const Pst_It_Solutions_FAQ = ({ program }) => {
  const programData = Array.isArray(program) ? program[0] : program;
//   const faqData = programData?.faq || [];
  const faqData = [
    {
      id: "01",
      question: "Are these outcomes independently verified?",
      answer:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    {
      id: "02",
      question: "Who is included in this outcomes report?",
      answer:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    {
      id: "03",
      question: "Do you guarantee 100 percent placements?",
      answer:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    {
      id: "04",
      question: "How are salary improvements calculated?",
      answer:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    {
      id: "05",
      question: "I already earn well. How is this relevant for me?",
      answer:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
  ];
  return (
    <section className="FAQ_div">
      <div className="container">
        <div className="FAQ_header">
          <h5>
            {" "}
            FREQUENTLY <span> ASKED QUESTIONS</span>{" "}
          </h5>
        </div>

        <div className="FAQ_section">
          {faqData.length > 0 ? (
            <Accordion defaultActiveKey="0">
              {faqData.map((item, index) => (
                <Accordion.Item
                  eventKey={index.toString()}
                  key={item.id}
                  className="mb-3"
                >
                  <Accordion.Header>
                    <span className="faq_number">{index + 1}</span>{" "}
                    <span className="faq_question">{item.question}</span>
                  </Accordion.Header>
                  <Accordion.Body>{item.answer}</Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          ) : (
            <div className="text-center my-4">
              <p className="text-muted">
                No Frequently Asked Questions Available
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Pst_It_Solutions_FAQ;
